import { calculateLegendSize } from './calculate-legend-size.js';
import { Orientation } from '../../../../../core/types/orientation.js';
import { LegendRatio } from '../../../types/legend.js';
import type {
  ChartLayoutLegendSizes,
  OverrideRatioFunction,
} from '../types/chart-layout.js';

export const getInitialDimensions = (
  orientation: Orientation,
  width: number,
  height: number,
  containerWidth: number,
  containerHeight: number,
  ratio: LegendRatio,
  ratioBoundaries: ChartLayoutLegendSizes,
  legendCandidateSize?: number,
  overrideRatio?: OverrideRatioFunction,
) => {
  const legendContainerDimensions = calculateLegendSize(
    orientation,
    containerWidth,
    containerHeight,
    ratio,
    ratioBoundaries,
    legendCandidateSize,
  );

  const overriddenDimensions = overrideRatio?.(
    orientation,
    width,
    height,
    ratio,
    legendContainerDimensions,
  );

  return overriddenDimensions ?? legendContainerDimensions;
};
